<template>
  <div class="switch-wrapper">
    <span v-if="label" class="txt" :class="{ active: value }">{{ label }}</span>
    <div class="switch-btn" :class="{ active: value }" @click="toggle">
      <span class="circle"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MSwitch',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
      this.$emit('change', !this.value)
    }
  }
}
</script>

<style scoped lang="less">
.switch-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;

  .txt {
    font-weight: 400;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.4);
    &.active { color: #FDB03E; } //active
  }

  .switch-btn {
    width: 60px;
    height: 32px;
    background: #F5F5F5;
    border-radius: 18px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;

    .circle {
      position: absolute;
      left: 4px;
      top: 2px;
      width: 28px;
      height: 28px;
      background: #FFFFFF;
      border-radius: 50%;
      transition: all 0.3s;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &.active {
      background: #FDB03E;

      
      .circle {
        left: 30px;
      }
    }
  }
}
</style>
